import React from 'react';
import './TrialStatusBanner.css';

const TrialStatusBanner = ({ trialEndsAt, onUpgrade }) => {
  if (!trialEndsAt) return null;

  const trialEnd = new Date(trialEndsAt);
  const now = new Date();
  const daysRemaining = Math.ceil((trialEnd - now) / (1000 * 60 * 60 * 24));

  // Don't show banner if trial expired
  if (daysRemaining <= 0) return null;

  // Determine banner style based on urgency
  const getUrgencyLevel = (days) => {
    if (days <= 1) return 'critical';
    if (days <= 3) return 'warning';
    return 'info';
  };

  const urgency = getUrgencyLevel(daysRemaining);

  const getMessage = (days) => {
    if (days === 1) return `Last day of your free trial!`;
    return `${days} days left in your free trial`;
  };

  return (
    <div className={`trial-banner trial-banner-${urgency}`}>
      <div className="trial-banner-content">
        <div className="trial-banner-icon">
          {urgency === 'critical' ? '⏰' : urgency === 'warning' ? '⏳' : '🎉'}
        </div>
        <div className="trial-banner-text">
          <span className="trial-banner-message">
            {getMessage(daysRemaining)}
          </span>
          <span className="trial-banner-cta">
            Upgrade now to keep full access for just <strong>$5.99/month</strong>
          </span>
        </div>
        <button
          className="trial-banner-upgrade-btn"
          onClick={onUpgrade}
        >
          Upgrade Now
        </button>
      </div>
    </div>
  );
};

export default TrialStatusBanner;
